'use strict';
function _typeof(e) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
        return typeof e;
    } : function (e) {
        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
    })(e);
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var reportCount = 0, _default = function (e) {
        var o = 'number' == typeof window.__apiReportMaxCount ? window.__apiReportMaxCount : 50;
        if ('object' === ('undefined' == typeof BJ_REPORT ? 'undefined' : _typeof(BJ_REPORT)) && !0 === window.__apiReport && reportCount < o && 'object' === ('undefined' == typeof performance ? 'undefined' : _typeof(performance)) && 'function' == typeof performance.getEntries)
            for (var t = performance.getEntries(), r = t.length - 1; 0 < r; r--) {
                var n = t[r];
                if (n.name.includes(e)) {
                    window.BJ_REPORT.report(new Error(JSON.stringify({
                        costTime: n.duration,
                        url: e.substring(0, 200)
                    })), !1, 'slowApi');
                    break;
                }
            }
        reportCount++;
    };
exports.default = _default;